import { Tooltip } from "@material-ui/core";

const TooltipInfo = (props) => {
  return (
    <Tooltip
      title={
        <div
          style={{
            fontSize: "14px",
            fontWeight: "300",
            lineHeight: "1.3",
            padding: "5px"
          }}
        >
          {props.title}
        </div>
      }
      arrow="top"
    >
      <i
        className="fas fa-info-circle ms-2"
        style={{
          color: "#999",
          cursor: "pointer",
        }}
      ></i>
    </Tooltip>
  );
};

export default TooltipInfo
